import React from 'react'
import { Box, IconButton } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import fullLogo from '../../assets/fullLogo.svg'

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}))

const DrawerHeaderComponent = ({ handleDrawerClose }) => {
  const theme = useTheme()

  return (
    <DrawerHeader>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 50,
          width: 200,
          maxHeight: { xs: 233 },
          maxWidth: { xs: 350, md: 250 },
          marginTop: 2,
          marginBottom: 2,
        }}>
        <Box
          component='img'
          sx={{
            height: '100%',
            width: '100%',
          }}
          alt='Boodhana Infra Developers'
          src={fullLogo}
        />
      </Box>
      <IconButton onClick={handleDrawerClose}>
        {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
      </IconButton>
    </DrawerHeader>
  )
}

export default DrawerHeaderComponent
